


















import { Component, Vue } from 'vue-property-decorator';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ErrorBoundary from './views/ErrorBoundary.vue';
import {
  MainModule,
  SectionsModule,
  DocumentsModule,
  DisplayModule,
  NotificationsModule,
  UsersModule
} from '@/store/store.helper';
import { setInterval } from 'timers';
import LightenDarkenColor from './services/LightenDarkenColor';
import serviceAPI from './services/serviceAPI';
// import {  } from "@/view";

@Component({
  components: {
    ErrorBoundary,
  },
})
export default class App extends Vue {
  @MainModule.MainGetter private prettyLink;
  @MainModule.MainGetter private navBar;
  @MainModule.MainMutation private setPrettyLink;
  @MainModule.MainAction private initStore;
  @SectionsModule.SectionsAction private updateStatusByDeadline;
  @DocumentsModule.DocumentsGetter private mainThemeColor;
  @DisplayModule.DisplayMutation private setMainToolbarColor;
  @NotificationsModule.NotificationsAction private handleOnScreenMsg;
  @DocumentsModule.DocumentsGetter private documentLanguage;

  private isStoreCreated: boolean = false;
  private dialog = true;
  private isNotificationChangedVisible = false;


  public async created() {
    if (this.prettyLink === undefined) {
      // if there is no prettyLink -> check the params in router, else go to the default document -> "demo"
      const prettyLink =
        this.$route.params.prettyLink !== undefined
          ? this.$route.params.prettyLink
          : 'springfield';
      console.log('App.vue prettyLink=' + prettyLink + ' , Init Store');
      this.setPrettyLink(prettyLink);
      await this.initStore();
    }
    this.isStoreCreated = true;
    this.dialog = false;

    // set main toolbar color in display module and vuetify theme
    this.setMainToolbarColor();
    if (this.mainThemeColor) {
      this.$vuetify.theme.themeColor = this.mainThemeColor;
      this.$vuetify.theme.lightThemeColor = LightenDarkenColor(this.mainThemeColor, 45);
    }
    console.log('App.vue created themeColor, lightThemeColor: ', this.mainThemeColor, this.$vuetify.theme.lightThemeColor);

    if (this.documentLanguage) {
      this.$i18n.locale = this.documentLanguage;
      this.$vuetify.rtl = this.documentLanguage === 'he';
    }
    console.log('App.vue: Language is set to: ', this.$i18n.locale);

    // listen for background messages
    this.handleOnScreenMsg();
    this.updateNotificationsByURLQuery();
  }

  /**
   * Checks if a notification unsubscription token is present. If so, it is used in order to unsubscribe the user from a notification type
   */
  async updateNotificationsByURLQuery() {
    const unsubscribeToken = this.$route.query.unsubscribe;
    if (!unsubscribeToken || typeof unsubscribeToken !== 'string') {
      return;
    }
    this.isNotificationChangedVisible = await serviceAPI.unsubscribeUser(unsubscribeToken)
  }
}
